import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getAppointmentAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getAppointmentAnalysesEvents', 
  func: async ({ offset = 0, appointment_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/appointment_analyses/${appointment_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getFirstAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getFirstAnalysesEvents', 
  func: async ({ offset = 0, first_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/first_analyses/${first_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getSecondAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getSecondAnalysesEvents', 
  func: async ({ offset = 0, second_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/second_analyses/${second_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getThirdAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getThirdAnalysesEvents', 
  func: async ({ offset = 0, third_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/third_analyses/${third_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getFifthAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getFifthAnalysesEvents', 
  func: async ({ offset = 0, fifth_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/fifth_analyses/${fifth_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getSixthAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getSixthAnalysesEvents', 
  func: async ({ offset = 0, sixth_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/sixth_analyses/${sixth_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getStudyAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getStudyAnalysesEvents', 
  func: async ({ offset = 0, study_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/study_analyses/${study_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getSeventhAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getSeventhAnalysesEvents', 
  func: async ({ offset = 0, seventh_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/seventh_analyses/${seventh_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getWaterfallAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getWaterfallAnalysesEvents', 
  func: async ({ offset = 0, waterfall_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/waterfall_analyses/${waterfall_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getFillAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getFillAnalysesEvents', 
  func: async ({ offset = 0, fill_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/fill_analyses/${fill_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getEsignAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getEsignAnalysesEvents', 
  func: async ({ offset = 0, esign_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/esign_analyses/${esign_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getVoiceAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getVoiceAnalysesEvents', 
  func: async ({ offset = 0, voice_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/voice_analyses/${voice_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getReminderAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getReminderAnalysesEvents', 
  func: async ({ offset = 0, reminder_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/reminder_analyses/${reminder_analysis_id}/events`, { params });

    return response.data;
  } 
});
export const getReferralAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getReferralAnalysesEvents', 
  func: async ({ offset = 0, referral_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/referral_analyses/${referral_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getScheduleAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getScheduleAnalysesEvents', 
  func: async ({ offset = 0, schedule_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/schedule_analyses/${schedule_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getConfirmAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getConfirmAnalysesEvents', 
  func: async ({ offset = 0, confirm_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/confirm_analyses/${confirm_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getPenStudyAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getPenStudyAnalysesEvents', 
  func: async ({ offset = 0, pen_study_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/pen_study_analyses/${pen_study_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getSuperbillAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getSuperbillAnalysesEvents', 
  func: async ({ offset = 0, superbill_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/superbill_analyses/${superbill_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getBookAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getBookAnalysesEvents', 
  func: async ({ offset = 0, book_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/book_analyses/${book_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getPatientAnalysesEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getPatientAnalysesEvents', 
  func: async ({ offset = 0, patient_analysis_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/patient_analyses/${patient_analysis_id}/events`, { params });
    
    return response.data;
  } 
});
export const getStudyTasksEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getStudyTasksEvents', 
  func: async ({ offset = 0, study_task_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/study_tasks/${study_task_id}/events`, { params });

    return response.data;
  } 
});
export const getSuperbillTasksEvents = asyncThunkWrapper({ 
  model: 'events', 
  action: 'getSuperbillTasksEvents', 
  func: async ({ offset = 0, superbill_task_id }) => {
    const attributes = ['id', 'text', 'created_at', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'asc' }, attributes };
    const response = await axios.get(`/superbill_tasks/${superbill_task_id}/events`, { params });

    return response.data;
  } 
});
export const clearLocalAnalysesEvents = createAction('events/clearLocalAnalysesEvents');
export const clearLocalTasksEvents = createAction('events/clearLocalTasksEvents');